﻿import {VoyadoEngageWebTrackingService} from "../apps/services/voyadoEngageWebTracking.service";

export default class VoyadoEngageClearCart {
    private element: HTMLElement;

    constructor(element: HTMLElement) {
        this.element = element;
        const cartId = this.element.dataset.cartId;
        if (!cartId) return;
        VoyadoEngageWebTrackingService.emptyCart(cartId);
    }
}
